import { SALE_END_TIME, SALE_START_TIME } from "../constants";

export const SALE_TYPE = {
  Valentine: "Valentine",
} as const;

// Show Valentine's Sale
export const isSaleLive = (key?: keyof typeof SALE_TYPE) => {
  const currentDate = new Date();
  return key === SALE_TYPE.Valentine && currentDate >= SALE_START_TIME && currentDate <= SALE_END_TIME;
};
